export default "/fonts/vendor/katex/dist/KaTeX_SansSerif-Bold.ttf?5b49f4993ae22d7975b413caed1a4c01";